import {Injectable} from '@angular/core';
import {APIException, ExceptionDisplayLevel, ExceptionDto} from './exception.dto';
import {NbToastrService} from '@nebular/theme';

export interface ErrorInfo {
    code: string;
    messageTitle: string;
    messageBody: string;
}

@Injectable()
export class EnginErrorHandlerService {
    constructor(private toastrService: NbToastrService) {}

    public handleCustomException(exception: APIException) {
        // Empty response
        if (exception === null) {
            this.toastrService.danger(
                'Something went wrong. Please try again or contact your administrator.',
                'Internal error.',
                {duration: 10000},
            );
        } else {
            const exceptions = exception.exceptions as ExceptionDto[];
            exceptions
                .filter((f) => f.errorDisplayType === 'GLOBAL')
                .forEach((err) => {
                    this.sendToastr(`Error: ${err.message}`, err.exceptionDetail, 10000, err.errorLevel);
                });
        }
    }

    private sendToastr(message, detail, duration, level: ExceptionDisplayLevel) {
        switch (level) {
            case ExceptionDisplayLevel.DANGER:
                this.toastrService.danger(message, detail, {duration: duration});
                break;
            case ExceptionDisplayLevel.WARNING:
                this.toastrService.warning(message, detail, {duration: duration});
                break;
            case ExceptionDisplayLevel.INFO:
                this.toastrService.info(message, detail, {duration: duration});
                break;
            case ExceptionDisplayLevel.NONE:
                break;
        }
    }
}
